var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstruction1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:tv-signin-outline-sharp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8332 38.625H41.1666V37.2271C41.1666 35.3208 40.2346 33.8068 38.3707 32.6851C36.5069 31.5634 34.0499 31.0017 30.9999 31C27.9499 31 25.493 31.5617 23.6291 32.6851C21.7652 33.8085 20.8332 35.3225 20.8332 37.2271V38.625ZM30.9999 28.4583C32.3978 28.4583 33.595 27.961 34.5913 26.9664C35.5876 25.9717 36.0849 24.7746 36.0832 23.375C36.0832 21.9771 35.5859 20.7808 34.5913 19.7862C33.5966 18.7915 32.3995 18.2934 30.9999 18.2917C29.602 18.2917 28.4057 18.7898 27.4111 19.7862C26.4164 20.7825 25.9183 21.9788 25.9166 23.375C25.9166 24.7729 26.4147 25.97 27.4111 26.9664C28.4074 27.9627 29.6037 28.46 30.9999 28.4583ZM20.8332 53.875V48.7917H5.58325V8.125H56.4166V48.7917H41.1666V53.875H20.8332ZM10.6666 43.7083H51.3332V13.2083H10.6666V43.7083Z",
    fill: "#FFFAEC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruction1);
export default __webpack_public_path__ + "static/media/instruction-1.64760c0c8765559147d69701adb44d87.svg";
export { ForwardRef as ReactComponent };